let formatDate = (value,format = 'Y-M-D h:m:s') => {
    const formatNumber = n => `0${n}`.slice(-2)
    const date = new Date(value)
    const formatList = ['Y', 'M', 'D', 'h', 'm', 's']
    const resultList = []
    resultList.push(date.getFullYear().toString())
    resultList.push(formatNumber(date.getMonth() + 1))
    resultList.push(formatNumber(date.getDate()))
    resultList.push(formatNumber(date.getHours()))
    resultList.push(formatNumber(date.getMinutes()))
    resultList.push(formatNumber(date.getSeconds()))
    for (let i = 0; i < resultList.length; i++) {
        format = format.replace(formatList[i], resultList[i])
    }
    return format
}
export { formatDate }


// WEBPACK FOOTER //
// ./src/util/dateFilter.js